/**
 * Patients Module
 */
import Vue from "vue";
import router from "../../../router/router";
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import { store } from "../../store";
// States
const state = {
  prestataires: [],
  etablissements: [],
  patient: {},
  metriques: {},
  count: 0,
};

// Getters
const getters = {
  metriques: (state) => {
    return state.metriques;
  },
  prestataires: (state) => {
    return state.prestataires;
  },
  etablissements: (state) => {
    return state.etablissements;
  },

  patient: (state) => {
    return state.patient;
  },

  count: (state) => {
    return state.count;
  },
};

// Actions
const actions = {
  getPrestataires(context, payload) {
    function successCallback(response) {
      context.commit("getPrestatairesHandler", {
        prestataires: response.data["data"],
      });
    }

    function errorCallback(error) {
      Vue.swal(payload.errorMessages.error, "", "error");
    }

    const localToken = localStorage.getItem("ms-token");

    makeApiRequest(
      payload.args,
      apiModel.Prestataire.List,
      localToken,
      successCallback,
      errorCallback,
      payload.errorMessages
    );
  },
  getMetriques(context, payload) {
    function successCallback(response) {
      context.commit("getMetriquesHandler", {
        metriques: response.data["data"],
      });
    }

    function errorCallback(error) {
      Vue.swal(payload.errorMessages.error, "", "error");
    }

    const localToken = localStorage.getItem("ms-token");

    makeApiRequest(
      payload.args,
      apiModel.Metriques.List,
      localToken,
      successCallback,
      errorCallback,
      payload.errorMessages
    );
  },
  getEtablissements(context, payload) {
    function successCallback(response) {
      context.commit("getEtablissementsHandler", {
        etablissements: response.data["data"],
      });
    }

    function errorCallback(error) {
      Vue.swal(payload.errorMessages.error, "", "error");
    }

    const localToken = localStorage.getItem("ms-token");

    makeApiRequest(
      payload.args,
      apiModel.Etablissement.List,
      localToken,
      successCallback,
      errorCallback,
      payload.errorMessages
    );
  },
};

// Mutations
const mutations = {
  getPrestatairesHandler(state, { prestataires }) {
    // Update prestataires state
    state.prestataires = prestataires;
  },
  getMetriquesHandler(state, { metriques }) {
    // Update metriques state
    state.metriques = metriques;
  },
  getEtablissementsHandler(state, { etablissements }) {
    // Update prestataires state
    state.etablissements = etablissements;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
